export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=template&id=64ae3412&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/login.vue?vue&type=template&id=64ae3412&scoped=true
// module id = d4JA
// module chunks = 0